import { render, staticRenderFns } from "./ReferralPopup.vue?vue&type=template&id=7e3dd144&scoped=true&"
import script from "./ReferralPopup.vue?vue&type=script&lang=js&"
export * from "./ReferralPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReferralPopup.vue?vue&type=style&index=0&id=7e3dd144&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3dd144",
  null
  
)

export default component.exports